import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { defaultTheme } from '@canopysecurity/component-library';
import React, { useEffect, useMemo } from 'react';
import { CardContainer, CardKey } from '../../StyledComponents/Card';
import CondorSpinner from '../CondorSpinner';
import { Alert } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { getStableVersion } from '../../services/DeploymentService';

export const CardValue = styled.span`
  font-size: 1em;
  padding: 16px;
`;
const ClickableDiv = styled.div`
  cursor: pointer;

  &:hover {
    color: wheat;
    font-weight: bold;
    background-color: ${defaultTheme.colors.primaryOrange};
  }
`;

export default function StableVersion(props: { reRender: boolean }) {
  const navigate = useNavigate();

  const {
    data,
    isPending: loading,
    refetch,
  } = useQuery({
    queryKey: ['stableVersion'],
    queryFn: getStableVersion,
  });

  useEffect(() => {
    refetch();
  }, [props.reRender]);

  const stableVersion = useMemo(() => {
    return {
      version: data?.release?.semver?.toString(),
      deploymentId: data?.id && data.id.toString(),
    };
  }, [data]);

  return (
    <CardContainer>
      <div>
        {loading ? (
          <CondorSpinner />
        ) : (
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexBasis: '60%' }}>
                <CardKey>Stable Version</CardKey>
              </div>
              <div style={{ flexBasis: '40%' }}>
                {stableVersion && stableVersion.deploymentId ? (
                  <CardValue>
                    <ClickableDiv
                      onClick={() =>
                        navigate(`/details/${stableVersion.deploymentId}`)
                      }
                      role="button"
                      tabIndex={0}
                    >
                      {stableVersion.version}
                    </ClickableDiv>
                  </CardValue>
                ) : (
                  <Alert severity="warning">
                    WARNING!! No Stable Version found!
                  </Alert>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </CardContainer>
  );
}
